const API_BASE = import.meta.env.VITE_API_BASE || '';

async function request<T>(path: string, options?: RequestInit): Promise<T> {
    const res = await fetch(`${API_BASE}${path}`, {
        headers: { 'Content-Type': 'application/json' },
        ...options,
    });

    const data = await res.json();

    if (!res.ok) {
        throw new Error(data.message || `Request failed (${res.status})`);
    }

    return data as T;
}

export const api = {
    createGift: (body: unknown) =>
        request<{ giftId: string; shareUrl: string; deleteUrl: string; deleteToken: string }>(
            '/api/gifts',
            { method: 'POST', body: JSON.stringify(body) },
        ),

    getGift: (giftId: string) =>
        request<{
            giftId: string;
            title: string;
            description?: string;
            backgroundType: string;
            status: string;
            items: Array<{
                title: string;
                imageUrl: string;
                productUrl?: string;
                requestSize: boolean;
                requestColor: boolean;
                requestNote: boolean;
            }>;
            chosenItemIndex?: number;
            createdAt: string;
            branding?: {
                logoUrl: string;
                companyName: string;
                primaryColor: string;
            };
        }>(`/api/gifts/${giftId}`),

    chooseGift: (giftId: string, body: unknown) =>
        request<{ success: boolean; message: string; chosenItem: string }>(
            `/api/gifts/${giftId}/choose`,
            { method: 'POST', body: JSON.stringify(body) },
        ),

    deleteGift: (giftId: string, token: string) =>
        request<{ success: boolean }>(`/api/gifts/${giftId}?token=${token}`, { method: 'DELETE' }),

    presignUpload: (body: { filename: string; contentType: string }) =>
        request<{ uploadUrl: string; publicUrl: string }>('/api/uploads/presign', {
            method: 'POST',
            body: JSON.stringify(body),
        }),

    parseMetadata: (url: string) =>
        request<{ title?: string; description?: string; imageUrl?: string; siteName?: string }>(
            '/api/metadata/parse',
            { method: 'POST', body: JSON.stringify({ url }) },
        ),

    createWidgetSession: (body: unknown) =>
        request<{ sessionId: string }>('/api/widget/sessions', {
            method: 'POST',
            body: JSON.stringify(body),
        }),

    finalizeWidgetSession: (sessionId: string, body: unknown) =>
        request<{ giftId: string; shareUrl: string; deleteToken: string }>(
            `/api/widget/sessions/${sessionId}/finalize`,
            { method: 'POST', body: JSON.stringify(body) },
        ),

    sendThankYou: (giftId: string, body: { message: string; imageUrl?: string }) =>
        request<{ success: boolean; message: string }>(
            `/api/gifts/${giftId}/thank-you`,
            { method: 'POST', body: JSON.stringify(body) },
        ),
};
